import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE, STAGGER, TEXT_DELAY } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);

const HEADLINE_X = "-50vw";
const SUBLINE_X = "50vw";
const ITEM_Y = 16;
const ITEM_DURATION = DURATION * 0.85;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function getItemStagger(index) {
  return index * STAGGER + (index % 6) * 0.035;
}

function initGallerySection(section) {
  const headline = section.querySelector(".gallery__headline");
  const subline = section.querySelector(".gallery__subline");
  const items = [...section.querySelectorAll(".gallery__item")];

  if (!headline && !subline && !items.length) {
    return;
  }

  if (reducedMotion) {
    gsap.set([headline, subline, ...items].filter(Boolean), {
      x: 0,
      y: 0,
      opacity: 1,
    });
    section.classList.add("is-in-view");
    return;
  }

  if (headline) {
    gsap.set(headline, { x: HEADLINE_X, opacity: 0 });
  }

  if (subline) {
    gsap.set(subline, { x: SUBLINE_X, opacity: 0 });
  }

  items.forEach((item) => {
    gsap.set(item, { y: ITEM_Y, opacity: 0 });
  });

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (headline) {
        timeline.to(headline, { x: 0, opacity: 1 }, 0);
      }

      if (subline) {
        timeline.to(subline, { x: 0, opacity: 1 }, TEXT_DELAY);
      }

      if (items.length) {
        timeline.to(
          items,
          {
            y: 0,
            opacity: 1,
            duration: ITEM_DURATION,
            ease: EASE,
            stagger: getItemStagger,
          },
          TEXT_DELAY * 0.75,
        );
      }
    },
  });
}

document.querySelectorAll(".gallery").forEach(initGallerySection);

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
